import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                韩漫网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫网致力于为您提供<strong>高清韩国漫画</strong>的免费在线阅读，拥有丰富<strong>韩漫大全</strong>和易用网址，覆盖多种类型，让您尽情享受阅读的快乐。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/category/all" className="hover:text-primary-400 transition-colors cursor-pointer">漫画分类</a>
            </h4>
            <ul className="space-y-2">
              {['恋爱', '奇幻', '动作', '悬疑', '校园', '都市'].map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/category/${cat === '恋爱' ? 'romance' : cat === '奇幻' ? 'fantasy' : cat === '动作' ? 'action' : cat === '悬疑' ? 'thriller' : cat === '校园' ? 'campus' : 'urban'}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
            </h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-400">品牌介绍</span></li>
              <li><span className="text-sm text-background-400">联系我们</span></li>
              <li><span className="text-sm text-background-400">用户协议</span></li>
              <li><span className="text-sm text-background-400">隐私政策</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm text-background-400"></i>
                </div>
                <span className="text-sm text-background-400">contact@hanmanwang.com</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm text-background-400"></i>
                </div>
                <span className="text-sm text-background-400">400-888-8888</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫网 - 高清韩国漫画免费在线阅读。本站所有内容均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}